import { render, staticRenderFns } from "./ChoosePrice.vue?vue&type=template&id=50e83aad&scoped=true"
import script from "./ChoosePrice.vue?vue&type=script&lang=js"
export * from "./ChoosePrice.vue?vue&type=script&lang=js"
import style0 from "./ChoosePrice.vue?vue&type=style&index=0&id=50e83aad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e83aad",
  null
  
)

export default component.exports